// Deutsche Anzeige-Labels der audit_log-Aktionen (Stand 16.07.: 29 Aktions-Typen in Prod). Unbekannte
// Aktionen fallen auf den Roh-Code zurück — neue Backend-Aktionen erscheinen also sofort, nur unübersetzt.
export const ACTION_LABELS: Record<string, string> = {
  customer_delete: 'Kunde gelöscht',
  customer_anonymize: 'Kunde anonymisiert (DSGVO)',
  customer_export: 'Kunden-Datenauskunft (DSGVO)',
  vehicle_delete: 'Fahrzeug gelöscht',
  vehicle_anonymize: 'Fahrzeug anonymisiert (DSGVO)',
  order_delete: 'Auftrag gelöscht',
  invoice_created: 'Rechnung erstellt',
  invoice_cancelled: 'Rechnung storniert',
  user_create: 'Mitarbeiter angelegt',
  user_update: 'Mitarbeiter geändert',
  user_deactivate: 'Mitarbeiter deaktiviert',
  user_anonymize: 'Mitarbeiter anonymisiert (DSGVO)',
  '2fa_reset': '2FA zurückgesetzt',
  onboard_code_created: 'Onboarding-Code erstellt',
  reset_code_created: 'Reset-Code erstellt',
  reset_code_used: 'Reset-Code eingelöst',
  attendance_void: 'Stempel entwertet',
  attendance_correct_add: 'Stempel nachgetragen',
  estimate_approved: 'Kostenvoranschlag vom Kunden freigegeben',
  estimate_declined: 'Kostenvoranschlag vom Kunden abgelehnt',
  workshop_export: 'Werkstatt-Datenexport (DSGVO)',
  workshop_setup: 'Werkstatt eingerichtet',
  workshop_register: 'Werkstatt registriert',
  workshop_create: 'Werkstatt angelegt (Betreiber)',
  workshop_delete: 'Werkstatt gelöscht (Betreiber)',
  workshop_license_update: 'Lizenz geändert (Betreiber)',
  admin_user_create: 'Mitarbeiter angelegt (Betreiber)',
  superadmin_bootstrap: 'Betreiber-Konto eingerichtet',
  cross_tenant_access: '⚠ Fremdzugriffs-Versuch abgewehrt',
  impersonation_denied: '⚠ Support-Zugriff verweigert',
  impersonated_write: 'Änderung im Support-Modus (Betreiber)',
  // Kiosk-Terminal (Phase 3): der Stempel selbst sagt WESSEN Zeit erfasst wurde — dass er am Wandtablet
  // entstand und an welchem, steht nur hier. Das audit_log ist dafür die einzige unlöschbare Spur.
  kiosk_stamp: 'Am Terminal gestempelt',
  kiosk_stamp_unverified: 'Am Terminal ohne Verbindung erfasst (Nachtrag)',
  kiosk_device_paired: 'Terminal eingerichtet',
  kiosk_device_revoked: 'Terminal widerrufen',
  pin_set: 'Terminal-PIN gesetzt',
  pin_reset: 'Terminal-PIN zurückgesetzt',
}

export function actionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action
}
